document.documentElement.classList.add('js');

const toggleMenu = (button) => {
  const menu = document.getElementById(button.getAttribute('aria-controls'));
  if (!menu) return;
  const open = button.getAttribute('aria-expanded') === 'true';
  button.setAttribute('aria-expanded', String(!open));
  menu.hidden = open;
  document.body.classList.toggle('menu-open', !open);
};

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-menu-toggle]');
  if (button) toggleMenu(button);
  const mobileLink = event.target.closest('#MobileMenu a');
  if (mobileLink) {
    const openButton = document.querySelector('[data-menu-toggle][aria-expanded="true"]');
    if (openButton) toggleMenu(openButton);
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const button = document.querySelector('[data-menu-toggle][aria-expanded="true"]');
  if (button) toggleMenu(button);
});

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) entry.target.classList.add('is-visible');
  });
}, { threshold: 0.12 });

document.querySelectorAll('[data-reveal]').forEach((element) => observer.observe(element));


/* Join form city attribution */
const initializeJoinCity = () => {
  const requestedCity = new URLSearchParams(window.location.search).get('city');

  document.querySelectorAll('[data-city-select]').forEach((select) => {
    const hasRequestedCity = requestedCity && Array.from(select.options).some((option) => option.value === requestedCity);
    if (hasRequestedCity) select.value = requestedCity;
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeJoinCity, { once: true });
} else {
  initializeJoinCity();
}